import { ExternalLink } from "lucide-react"
import { safeHref } from "../safe-url"

type Props = {
  value: { label: string; href: string } | null | undefined
}

// Per-row deep link. Renders as plain text if the URL fails the
// client-side scheme check (server allowlist already enforced; this is
// belt-and-suspenders). Always opens in a new tab with no referrer to
// keep partner-side analytics from seeing operator IPs.
export function LinkCell({ value }: Props) {
  if (!value || typeof value !== "object" || !value.label || !value.href) {
    return <span className="text-app-subtle">—</span>
  }
  const safe = safeHref(value.href)
  if (safe === null) {
    return <span className="text-app-text">{value.label}</span>
  }
  return (
    <a
      href={safe}
      target="_blank"
      rel="noopener noreferrer"
      referrerPolicy="no-referrer"
      className="inline-flex items-center gap-1 text-brand-red underline-offset-2 hover:underline"
    >
      {value.label}
      <ExternalLink size={12} strokeWidth={2} aria-hidden="true" />
    </a>
  )
}
